import { useEvent } from "../../../context/EventContext";

/**
 * PastEvents component renders a list of past events the user has registered for.
 * It uses the useEvent hook to get the registered events from the event context.
 * If there are no registered events, it shows a message.
 * If there are registered events, it renders them in a list.
 * Each event is rendered with its image, name, location and start date.
 */
const PastEvents = () => {
  const { loading, registeredEvents } = useEvent();

  // Show a loading message while events are being fetched
  if (loading) {
    return <p>Loading events...</p>;
  }

  // If no events are registered, show a message
  if (registeredEvents.length === 0) {
    return <p>No past events found</p>;
  }

  return (
    <div className="past-events">
      {registeredEvents.map((event) => (
        <div className="past-event-card" key={event._id}>
          <img
            src={event.image_url || "https://imgur.com/FUD7JM8.jpg"}
            alt={event.event_name}
          />
          <div className="description">
            <h1>{event.event_name}</h1>
            <p>📍{event.location}</p>
            <p>📅{new Date(event.start_date).toLocaleDateString()}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PastEvents;
